import { Grid } from '@mui/material';
import { GVTypography } from 'components/lib';
import { DifferenceProps } from '../DifferenceElementView';

const BarcodeDifference = ({ classes: parentClasses, multipleSelectionMode = false }: DifferenceProps) => {
  return (
    <Grid container direction="column" className={parentClasses.classes.textContainer}>
      <GVTypography className={parentClasses.classes.text}>Select this card to view the barcode details</GVTypography>
    </Grid>
  );
};

export default BarcodeDifference;
